import { Box } from "@mui/material";

const sx = {
  root: (theme) => ({
    display: "flex",
    alignItems: "center",
    height: 28,
    px: 1.5,
    py: 0.25,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.custom.panelChrome,
  }),
};

const PanelFooter = ({ children }) => (
  <Box sx={sx.root}>{children}</Box>
);

export default PanelFooter;
